// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

MarkdownComponent['{ Link }'] = 'react-router-dom';

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="february-4-2022">February 4, 2022</h3>
      <p>We added a new API to the developer portal. This API was previously the EVSS Data Reference Service. It allows consumers to look up the following data for use with benefits claims:</p>
      <ul>
      <li>Contention types</li>
      <li>Countries</li>
      <li>Disabilities</li>
      <li>Intake sites</li>
      <li>Military pay types</li>
      <li>Service branches</li>
      <li>Special circumstances</li>
      <li>States</li>
      <li>VA medical treatment facilities</li>
      </ul>
      <p>This API will return only the data that can be used for benefits claims. For example, this API may return only a subset of states or countries that apply to benefits claims.</p>
      <p>There are some important differences between this API and the service it replaces:</p>
      <ul>
      <li>
      <p>The new service requires an API key. <a href="https://developer.va.gov/onboarding">Obtain one through this onboarding process</a>.</p>
      </li>
      <li>
      <p>There are some stylistic changes to each endpoints’ response format:</p>
      <ul>
      <li>Contention Types
      <ul>
      <li>&quot;contentionTypes&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>Countries
      <ul>
      <li>&quot;countries&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>Disabilities
      <ul>
      <li>&quot;disability&quot; array renamed to &quot;items&quot;</li>
      <li>&quot;classificationCode&quot; renamed to &quot;id&quot;</li>
      <li>&quot;id&quot; is type long</li>
      <li>&quot;endDate&quot; renamed to &quot;endDateTime&quot;</li>
      <li>&quot;endDateTime&quot; reported in YYY-MM-DDTHH:MM:SSZ format</li>
      <li>&quot;endDateTime&quot; always included, even if null</li>
      </ul>
      </li>
      <li>Intake Sites
      <ul>
      <li>&quot;intakeSites&quot; array renamed to &quot;items&quot;</li>
      <li>&quot;code&quot; renamed to &quot;id&quot;</li>
      <li>&quot;id&quot; is type long</li>
      </ul>
      </li>
      <li>Military Pay Types
      <ul>
      <li>&quot;militaryPayTypes&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>Service Branches
      <ul>
      <li>&quot;serviceBranches&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>Special Circumstances
      <ul>
      <li>&quot;specialCircumstances&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>States
      <ul>
      <li>&quot;states&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      <li>Treatment Centers
      <ul>
      <li>&quot;facilities&quot; array renamed to &quot;items&quot;</li>
      </ul>
      </li>
      </ul>
      </li>
      <li>
      <p>Responses are in JSON instead of HTML.</p>
      </li>
      <li>
      <p>Minor improvements to HTTPS Response Codes. (i.e. treatment centers invalid state was 200 and is now 400, new 429 rate limit errors, unauthorized 401, refer to <a href="https://developer.va.gov/explore/benefits/docs/benefits_reference_data?version=current">API specification</a> for complete information).</p>
      </li>
      <li>
      <p>For the treatment center endpoint, the optional “stateCode” query parameter must now be 2 capital letters, otherwise a 400 response is returned. Previously, a 200 with a blank array was returned.</p>
      </li>
      <li>
      <p>Optional pagination is supported (new fields were added to in the responses even if the optional pagination parameters are not used for certain end points).</p>
      </li>
      <li>
      <p>URLs for the services are changed. The legacy production URLs are https://www.ebenefits.va.gov:444/wss-referencedata-services-web/rest/referencedata/v1/<code>&lt;endpoint name&gt;</code> and the new production URLs are: https://api.va.gov/services/benefits-reference-data/v1/<code>&lt;endpoint name&gt;</code>.</p>
      </li>
      </ul>
      <p>It's important to know that with the new version, you will need to support backward compatibility. You should:</p>
      <ul>
      <li>Be prepared to handle HTTP status codes not explicitly specified in endpoint definitions.</li>
      <li>Be tolerant with unknown fields in the payload, ignore deserialization of new fields, but do not eliminate them from the payload if needed for subsequent PUT requests.</li>
      <li>Follow the redirect when the server returns HTTP status code 301 (Moved Permanently).</li>
      </ul>
      <p>Learn more about this API by reviewing the <a href="/explore/benefits/docs/benefits_reference_data">Benefits Reference Data API documentation</a>.</p>
      <p>For cross-reference purposes, the PR for this release is <a href="https://tools.health.dev-developer.va.gov/jenkins/job/department-of-veterans-affairs/job/health-apis-deployer/job/d2/4015/">#4015</a>.</p>
    </div>
  );
};

export default MarkdownComponent;
